


















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import StrategySelect from "./StrategySelect.vue";
import StrategyForm from "./StrategyForm.vue";
import StrategyTips from "./StrategyTips.vue";
import {
  ATMAsset,
  TradeSide,
  TradeStrategy
} from "@foxone/api/src/models/market";
import utils from "trade/utils";
import { AUTO_TRADE_INSTRUCTION } from "trade/constants";

@Component({
  components: {
    StrategySelect,
    StrategyForm,
    StrategyTips
  }
})
class AutoTradeCreatePage extends Vue {
  @Getter("trade/getPairsByStrategy") getPairsByStrategy;

  @Mutation("trade/SET_AUTO_ASSETS") setAutoAssets;

  loading = false;

  isQuantityValid = false;

  balance: any = null;

  quantifyErrorMessage = "";

  quantityValue = "";

  order: any = null;

  wantAsset: ATMAsset | null = null;

  offerAsset: ATMAsset | null = null;

  strategy: any = "";

  get meta() {
    let pair: any = null;
    let symbol = "";
    let wantAssets: any[] = [];
    let offerAssets: any[] = [];

    const { wantAsset, offerAsset, strategy, isQuantityValid } = this;
    const isBuy = strategy.side === TradeSide.BID;
    const strategies = utils.trade
      .getAutoTradeStrategies(this)
      .filter(s => !s.disabled);
    const pairs = this.getPairsByStrategy(TradeStrategy.FLEX) || [];

    const baseAssetMap = {};
    const quoteAssetMap = {};
    const pairMap = {};
    pairs.reduce((map, pair) => {
      baseAssetMap[pair.base.symbol] = pair.base;
      quoteAssetMap[pair.quote.symbol] = pair.quote;
      pairMap[pair.base.symbol + pair.quote.symbol] = pair;
    }, {});

    const baseAssets = Object.values(baseAssetMap).map((asset: any) => ({
      id: asset.asset_id,
      logo: asset.icon_url,
      chainLogo: this.$common.utils.helper.getChainLogo(this, asset),
      ...asset
    }));
    const quoteAssets = Object.values(quoteAssetMap).map((asset: any) => ({
      id: asset.asset_id,
      logo: asset.icon_url,
      chainLogo: this.$common.utils.helper.getChainLogo(this, asset),
      ...asset
    }));

    wantAssets = isBuy ? baseAssets : quoteAssets;
    offerAssets = isBuy ? quoteAssets : baseAssets;

    if (wantAsset) {
      offerAssets.filter(asset => {
        const sym = isBuy
          ? `${wantAsset.symbol}${asset.symbol}`
          : `${asset.symbol}${wantAsset.symbol}`;
        return pairMap[sym];
      });
    }

    if (offerAsset) {
      wantAssets.filter(asset => {
        const sym = isBuy
          ? `${asset.symbol}${offerAsset.symbol}`
          : `${offerAsset.symbol}${asset.symbol}`;
        return pairMap[sym];
      });
    }

    if (wantAsset && offerAsset) {
      symbol = isBuy
        ? `${wantAsset.symbol}${offerAsset.symbol}`
        : `${offerAsset.symbol}${wantAsset.symbol}`;
      pair = pairMap[symbol];
    }

    const quantity = {
      field: "quantity",
      value: this.quantityValue,
      precision: (offerAsset && offerAsset.precision) || 0,
      rules: [
        v => +v > 0 || this.$t("common.amount.invalid"),
        v => {
          const offerAsset = this.offerAsset;
          if (offerAsset && pair) {
            const asset =
              pair.base.symbol === offerAsset.symbol ? pair.base : pair.quote;
            const min = (asset.minimums && asset.minimums.flex) || 0;
            // const max = +asset.max || Infinity;
            const text = this.$t("common.amount.out-of-limit");
            if (+v < +min) {
              return text;
            }
          }
          return true;
        },
        v => {
          if (this.balance === null) {
            return true;
          }
          if (v > +(this.balance || "")) {
            return this.$t("common.balance.inffrence");
          }
          return true;
        }
      ]
    };

    return {
      isValid: isQuantityValid && offerAsset && wantAsset && pair,
      strategies,
      isBuy,
      wantAssets,
      offerAssets,
      pair,
      symbol,
      quantity
    };
  }

  mounted() {
    this.$nextTick(() => {
      if (!this.offerAsset) {
        this.offerAsset = this.meta.offerAssets[0];
      }
      if (!this.wantAsset) {
        this.wantAsset = this.meta.wantAssets[0];
      }
      if (!this.strategy) {
        this.strategy = this.meta.strategies[0];
      }
    });
  }

  beforeDestroy() {
    this.order = null;
  }

  @Watch("strategy")
  handlePairsChange() {
    this.$nextTick(() => {
      this.offerAsset = this.meta.offerAssets[0];
      this.wantAsset = this.meta.wantAssets[0];
    });
  }

  @Watch("offerAsset", { immediate: true })
  handleAssetChange() {
    this.requestAsset();
  }

  @Watch("quantityValue", { immediate: true })
  handleQuantityChange() {
    this.handleSetQuantityMessage();
  }

  handleSetStrategyOptionValue(index, v) {
    Vue.set(this.strategy.options[index], "value", v);
  }

  handleSetQuantityMessage() {
    setTimeout(() => {
      const form: any = this.$refs.form;
      if (!form) return;
      this.quantifyErrorMessage = form.inputs[0].messagesToDisplay[0];
    }, 200);
  }

  handleViewDetail() {
    window.location.href = AUTO_TRADE_INSTRUCTION;
  }

  handleSubmit() {
    const strategyForm = this.$refs.strategyForm as any;
    let values = strategyForm.submit();
    if (values) {
      const form = this.$refs.form as any;
      const valid = form.validate();
      if (valid) {
        values = {
          ...values,
          pair: this.meta.pair.symbol,
          strategy: TradeStrategy.FLEX,
          quantity: this.meta.quantity.value
        };
        this.requestPutOrder(values);
      } else {
        this.handleSetQuantityMessage();
      }
    }
  }

  async requestAsset() {
    try {
      if (!this.offerAsset) {
        return;
      }
      const data = await this.$api.wallet.mixin.getAsset(
        this.offerAsset.asset_id
      );
      this.balance = data.balance;
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  async requestPutOrder(values) {
    this.loading = true;
    try {
      const order = await this.$api.market.putOrder(values);
      this.order = order;
      const payment = await this.$api.market.requestPayOrder(order.id + "");
      utils.order.payment(this, payment, order.id + "", () => {
        this.handleToOrder();
      });
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }

  handleClickBalance() {
    this.quantityValue = this.balance;
  }

  handleToOrder() {
    if (this.order && this.order.id) {
      this.$helper.toFusionPath(this, "trade", {
        name: "orders-id",
        params: { id: this.order.id }
      });
    }
  }
}

export default AutoTradeCreatePage;
